import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';

import infracoes_api from '../../../api/infracoes_api';
import { showMessage } from '../../../helpers/message';

// Components
import FichaRocSeparada from './_components/FichaRocSeparada';
import ComprovanteEnvioEmailSeparado from './_components/ComprovanteEnvioEmailSeparado';
import FichaHtmlSeparada from './_components/FichaHtmlSeparada';
import FichaPdfSeparada from './_components/FichaPdfSeparada';
import AvisoItemSemConteudo from '../FichaImpressaoCompleta/_components/AvisoItemSemConteudo';

// A URL carrega só os hashes. Tipo, formato e identificação do item vêm do backend pelo
// parametrizacaoHash — assim o visualizador não depende de parâmetro montado na tela de origem.
export default function FichaImpressaoSeparada() {
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const hash = query.get('hash');
    const parametrizacaoHash = query.get('parametrizacaoHash');

    const [item, setItem] = useState(null);
    const [numeroInfracao, setNumeroInfracao] = useState("");

    useEffect(() => {
        if (!hash) return;

        infracoes_api.GetItemFiscalizacaoHash(hash)
            .then(({ data }) => setNumeroInfracao(data?.numeroInfracao ?? ""))
            .catch(() => setNumeroInfracao(""));
    }, [hash]);

    useEffect(() => {
        if (!hash || !parametrizacaoHash) return;

        infracoes_api.GetImpressaoItensDisponiveis(hash)
            .then(({ data }) => {
                const itens = [...(data?.documentosSeparados ?? []), ...(data?.itensCompleta ?? [])];
                const encontrado = itens.find(x => x.hash === parametrizacaoHash);

                if (encontrado)
                    setItem(encontrado);
                else
                    showMessage("Erro", "Item de impressão não encontrado.", "error", null);
            })
            .catch(error => showMessage("Erro", error?.message ?? "Não foi possível carregar o documento.", "error", null));
    }, [hash, parametrizacaoHash]);

    if (!hash || !parametrizacaoHash || !item) return <></>;

    if (item.formato === "FichaProtocoloROC")
        return <FichaRocSeparada hash={hash} parametrizacaoHash={parametrizacaoHash} numeroInfracao={numeroInfracao} />;

    if (item.formato === "ComprovanteEnvioEmail")
        return <ComprovanteEnvioEmailSeparado hash={hash} />;

    if (item.formato === "Pdf")
        return <FichaPdfSeparada hash={hash} parametrizacaoHash={parametrizacaoHash} titulo={item.identificacao} numeroInfracao={numeroInfracao} />;

    if (item.formato === "Html")
        return <FichaHtmlSeparada hash={hash} parametrizacaoHash={parametrizacaoHash} titulo={item.identificacao} numeroInfracao={numeroInfracao} />;

    return (
        <div className="p-3">
            <AvisoItemSemConteudo
                titulo={item.identificacao ?? "Documento"}
                mensagem="Este item não pode ser aberto por esta tela. Use o botão de impressão na ficha da infração."
            />
        </div>
    );
}
